import { CatalogListTabType } from './catalogListTabType.enum';
import catalogListTabs from './catalogListTabs';
import {
  CatalogListTab,
  CatalogListTabCounts,
  CatalogStatusValue,
  ResolveCatalogListTabParams,
} from './catalogListTabs.types';

export const CATALOG_LIST_STATUS_SEARCH_PARAM = 'status';

export const CATALOG_LIST_ALL_STATUS_SEARCH_VALUE = 'all';

export const getVisibleCatalogListTabs = (canManageBrandCatalogs: boolean): CatalogListTab[] => {
  if (canManageBrandCatalogs) {
    return catalogListTabs;
  }

  return catalogListTabs.filter((tab) => !tab.isAdminOnly);
};

export const getCatalogStatusByTab = (tab: CatalogListTabType): CatalogStatusValue[] =>
  catalogListTabs.find((listTab) => listTab.name === tab)?.status ?? [];

export const getCatalogStatusFilterByTab = (
  tab: CatalogListTabType,
): CatalogStatusValue | undefined => getCatalogStatusByTab(tab)[0];

export const getDefaultCatalogListTab = (visibleTabs: CatalogListTab[]): CatalogListTabType => {
  const hasActiveTab = visibleTabs.some((tab) => tab.name === CatalogListTabType.ACTIVE);

  return hasActiveTab ? CatalogListTabType.ACTIVE : CatalogListTabType.ALL;
};

export const getCatalogListTabSearchValue = (tab: CatalogListTabType): string =>
  getCatalogStatusFilterByTab(tab) ?? CATALOG_LIST_ALL_STATUS_SEARCH_VALUE;

export const resolveCatalogListTab = ({
  status,
  visibleTabs,
}: ResolveCatalogListTabParams): CatalogListTabType => {
  if (typeof status !== 'string') {
    return getDefaultCatalogListTab(visibleTabs);
  }

  if (status === CATALOG_LIST_ALL_STATUS_SEARCH_VALUE) {
    return CatalogListTabType.ALL;
  }

  const matchedTab = visibleTabs.find((tab) => tab.status.length === 1 && tab.status[0] === status);

  return matchedTab?.name ?? getDefaultCatalogListTab(visibleTabs);
};

const catalogListStatusTabs = catalogListTabs.filter((tab) => tab.name !== CatalogListTabType.ALL);

export const getCatalogListTabCounts = (
  facets: Record<string, number> | undefined,
): CatalogListTabCounts => {
  if (!facets) {
    return {};
  }

  const statusCounts = catalogListStatusTabs.reduce<CatalogListTabCounts>((counts, tab) => {
    const count = facets[tab.name];

    if (typeof count !== 'number') {
      return counts;
    }

    return { ...counts, [tab.name]: count };
  }, {});

  const statusValues = Object.values(statusCounts);

  if (statusValues.length === 0) {
    return statusCounts;
  }

  return {
    ...statusCounts,
    [CatalogListTabType.ALL]: statusValues.reduce((total, count) => total + count, 0),
  };
};
